<template>
  <v-timeline-item small class="pb-3">
    <template v-slot:icon>
      <img class="icon" v-if="electionIcon" :src="electionIcon" />
    </template>

    <v-card class="pa-3">
      <v-card-title class="card-title pa-0 mb-5">
        {{ title }}
      </v-card-title>

      <v-card-subtitle v-if="countryNameLink" class="card-subtitle pa-0">
        <DetailsListItemClickable :content="countryNameLink" />
      </v-card-subtitle>

      <v-card-text class="pa-0 body">
        <div v-html="body"></div>
      </v-card-text>
    </v-card>
  </v-timeline-item>
</template>

<script>
import lodashGet from "lodash/get";

export default {
  name: "FutureEventsTimelineItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  components: {
    DetailsListItemClickable: () =>
      import("@/components/common/details/DetailsListItemClickable"),
  },
  computed: {
    //TODO this oughta be dynamic but its not yet
    electionIcon() {
      return require("@/assets/svgs/election_grey.svg");
    },
    formatted() {
      let formatted = lodashGet(this.item, "properties.formatted");
      if (formatted) {
        return formatted;
      }
      return null;
    },
    title() {
      return lodashGet(this.formatted, "title");
    },
    body() {
      return lodashGet(this.formatted, "summary");
    },
    dateTime() {
      if (this.formatted && this.formatted.occurred) {
        return getFormatted(this.formatted.occurred);
      }
      return null;
    },
    flagUrl() {
      return lodashGet(this.item, "properties.flagUrl");
    },
    countryNameLink() {
      let countries = lodashGet(this.item, "properties.countryName") || [];
      for (let i = 0; i < countries.length; i++) {
        if (countries[i].languageCode === "en") {
          let countryText = `<a data-country-name="${countries[i].text}">`;
          countryText += `<img src="${this.flagUrl}" height="14" class="ml-1" style="border:1px solid #d1d1d1; border-radius:7px; position:relative; top:3px;" data-country-name="${countries[i].text}" />`;
          countryText += ` <span class="mr-1" data-country-name="${countries[i].text}">${countries[i].text}</span></a>`;
          return countryText;
        }
      }
      return null;
    },
  },
};
</script>

<style scoped>
.card-title {
  word-break: break-word;
  font-size: 1em;
  line-height: 1.4em;
}

.card-subtitle {
  font-size: 0.75em;
}

.icon {
  height: 40px;
}

.body {
  font-size: 0.8em;
  line-height: 1.4em;
}

.flagIcon {
  border: 1px solid #d1d1d1;
  border-radius: 7px;
  position: relative;
  top: 3px;
}
</style>
